import { Component, inject, isDevMode } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';
import { AlertComponent } from '@shared/components/alert/alert.component';
import { ImageViewerComponent } from '@shared/components/image-viewer/image-viewer.component';
import { CommonService } from '@shared/services/Common/common.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AlertComponent, ImageViewerComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'CoachTools';

  private swUpdate = inject(SwUpdate);
  private commonService = inject(CommonService);

  constructor() {
    if (isDevMode()) return;

    this.swUpdate.versionUpdates.pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')).subscribe(() => {
      this.commonService.showAlert('info', 'Nueva versión disponible. Actualizando…', 10000);

      this.swUpdate.activateUpdate().then(() => {
        window.location.reload();
      });
    });
  }
}
